module.exports = __webpack_public_path__ + "static/img/logo103.f4f3343.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo103.png
// module id = Gvu8
// module chunks = 1